export default __webpack_public_path__ + "static/media/getHelp.c28c1243.svg";